import type { TypedDataSigner } from '@ethersproject/abstract-signer'
import { BigNumber, Signer } from 'ethers'
import { DependencyInjector } from '~/injector/clientDependencyInjector'
import { SignableRequest } from '~/modules/Products/Domain/SignableRequest'
import { TrophyApiServiceInterface } from '~/modules/Trophies/Domain/TrophyApiServiceInterface'

/**
 * Request backend to mint a trophy NFT
 *
 * This use case is initiated client-side to request minting a trophy in the blockchain. It will call the proper API
 * endpoint with the corresponding authentication method.
 *
 * @param signer EthersJS signer used to sign mint request
 * @param networkId ID of the blockchain where the trophy is to be minted
 * @param trophyId ID of the trophy to mint
 * @param account Account of the user requesting the mint
 */
export default async function requestMint (
  signer: Signer & TypedDataSigner,
  networkId: number,
  trophyId: BigNumber,
  account: string
) {
  const api: TrophyApiServiceInterface =
    DependencyInjector.getInstance().resolve('TrophyApiServiceInterface')

  const trophyCategory = 'trophy'
  const mintAction = 'mint'
  const mintRequest = new SignableRequest(
    signer,
    networkId,
    account,
    trophyCategory,
    trophyId.toString(),
    mintAction
  )

  await api.mint(mintRequest)
}
